// 12 seasonal offers keyed by month (0 = January … 11 = December).
// Edit the copy / cta / accent color anytime — the bar auto-picks the
// current month via new Date().getMonth().
//
// Tip: keep the message short — the bar is a single slim line.
// Icons: use short unicode symbols only (renders on every browser).
const MONTHLY_OFFERS = [
  {
    // January
    icon: "✨",
    message: "New Year Refresh: 10% off Wi-Fi Mesh + Smart Home upgrades this month.",
    cta: "Claim Offer",
    accent: "from-sky-500 to-blue-600",
  },
  {
    // February — Snowbird Season (current default per user)
    icon: "❄️",
    message: "Snowbird Season Special: 10% off TV Mounting + Wi-Fi Setup bundles.",
    cta: "Get Bundle",
    accent: "from-cyan-500 to-blue-600",
  },
  {
    // March
    icon: "🌤️",
    message: "Spring Prep: Free network health check with any Wi-Fi install this month.",
    cta: "Book Now",
    accent: "from-emerald-500 to-teal-600",
  },
  {
    // April
    icon: "🎬",
    message: "Home Theater Season: Free in-home consultation on any theater install.",
    cta: "Reserve Consult",
    accent: "from-indigo-500 to-purple-600",
  },
  {
    // May
    icon: "🎥",
    message: "Summer Ready: 10% off Ring & Nest security camera installs booked this month.",
    cta: "Get 10% Off",
    accent: "from-blue-500 to-indigo-600",
  },
  {
    // June
    icon: "⚡",
    message: "Hurricane Prep: Free surge protection consult with any smart home upgrade.",
    cta: "Prep My Home",
    accent: "from-amber-500 to-orange-600",
  },
  {
    // July
    icon: "📶",
    message: "Mid-Year Refresh: 10% off UniFi network upgrades for the whole home.",
    cta: "Upgrade Wi-Fi",
    accent: "from-sky-500 to-indigo-600",
  },
  {
    // August
    icon: "💼",
    message: "Back to Business: Free IT audit for SWFL small businesses booked this month.",
    cta: "Book Audit",
    accent: "from-slate-500 to-blue-600",
  },
  {
    // September
    icon: "🎧",
    message: "Fall Kickoff: 10% off Sonos multi-room audio installs booked this month.",
    cta: "Get 10% Off",
    accent: "from-purple-500 to-pink-600",
  },
  {
    // October
    icon: "🏡",
    message: "Snowbird Return: Priority booking for seasonal home turn-ons — reserve today.",
    cta: "Reserve Slot",
    accent: "from-orange-500 to-red-600",
  },
  {
    // November
    icon: "📺",
    message: "Holiday Ready: 10% off any TV Mounting + Sound Bar bundle this month.",
    cta: "Get Bundle",
    accent: "from-rose-500 to-red-600",
  },
  {
    // December
    icon: "🎁",
    message: "Book now, install after the holidays — no rush pricing, guaranteed slots.",
    cta: "Reserve Install",
    accent: "from-emerald-500 to-green-600",
  },
];

export function getCurrentMonthlyOffer(date = new Date()) {
  return MONTHLY_OFFERS[date.getMonth()];
}

export default MONTHLY_OFFERS;
